import { NgModule, Optional, SkipSelf } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DataStorageService } from '@app/shared';
import { LocalStorageService } from '@app/core';
import { AuthenticationService } from '@app/core/authentication/authentication.service';
import { provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { MatModule } from '.';

@NgModule({ exports: [
        RouterModule,
        MatModule
    ], imports: [CommonModule,
        RouterModule,
        MatModule], providers: [
        DataStorageService,
        LocalStorageService,
        AuthenticationService,
        provideHttpClient(withXhr(), withInterceptorsFromDi()),
    ] })
export class CoreModule {
  constructor(
    @Optional()
    @SkipSelf()
    parentMod?: CoreModule
  ) {
    if (parentMod) {
      // dont import the core mod anywhere else, services declared within this mod
      throw new Error(`${parentMod} has already been loaded. Import Core module in the AppModule only`);
    }
  }
}
